<div class="landing-feedback-container">
  <div class="landing-feedback-header">
    <div class="feedback-header-section-one">
      <div class="landing-feedback-header-title"><h2>Feedback form</h2></div>
      <div class="landing-feedback-title-description">
        A feedback form helps you gather information to analyze and improve AI
        responses.
      </div>
    </div>
    <div class="feedback-header-section-two">
      <button class="customization-button" (click)="redirectToFeedback()">Customize form</button>
    </div>
  </div>
  <div *ngIf="!featureFlags.feedbackFormReportsFeature" class="landing-feedback-info-container">
    <div class="info-icon">
      <!-- icon -->
      <svg
        id="info-mono.svg"
        width="16"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4C16.41 4 20 7.58998 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.58998 7.59 4 12 4ZM12 2C6.48 2 2 6.47998 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.47998 17.52 2 12 2Z"
          fill="#1B1B1D"
        />
        <path d="M13 10.5H11V17.5H13V10.5Z" fill="#1B1B1D" />
        <path d="M13 6.5H11V8.5H13V6.5Z" fill="#1B1B1D" />
      </svg>
    </div>
    <div class="info-description">
      Contact the Gen.AI general inbox to request permission from the
      administrator to access the database where all user answers are stored.
    </div>
  </div>
  <form *ngIf="featureFlags.feedbackFormReportsFeature" [formGroup]="feedbackReportsForm" (ngSubmit)="downloadExcel()">
    <div class="feedback-reports-container">
      <div class="info-container">
        <div>
          <h4 class="reports-title">Download Feedback Responses</h4>
          <span class="reports-sub-title">Please select the date range to download the feedback responses.</span>
        </div>
      </div>
      <div class="start-date-container">
        <div>
          <span class="date-input-header">Start date:</span>
        </div>
        <div>
          <input type="date" formControlName="start_date" class="custom-date-input">
          <div class="error" *ngIf="feedbackReportsForm.get('start_date')?.value && feedbackReportsForm.get('start_date')?.value < '2024-03-01'">
            Start date must be on or after March 1, 2024.
          </div>
          <div class="error" *ngIf="feedbackReportsForm.get('start_date')?.value && feedbackReportsForm.get('start_date')?.value > cutoffDate">
            The start date cannot be set to a future date.
          </div>
        </div>
      </div>
      <div class="end-date-container">
        <div>
          <span class="date-input-header">End date:</span>
        </div>
        <div>
          <input type="date" formControlName="end_date" class="custom-date-input">
          <div class="error" *ngIf="feedbackReportsForm.get('end_date')?.value && feedbackReportsForm.get('end_date')?.value > cutoffDate">
            The end date cannot be set to a future date.
          </div>
          <div class="error" *ngIf="feedbackReportsForm.errors?.['dateRangeInvalid'] && feedbackReportsForm.get('start_date')?.value && feedbackReportsForm.get('end_date')?.value && feedbackReportsForm.get('start_date')?.value > feedbackReportsForm.get('end_date')?.value">
            The end date should be greater than or equal to the start date.
          </div>
        </div>
      </div>
      <div class="submit-button-container">
        <button 
          kmdPrimaryButton
          type="submit" 
          [disabled]="!feedbackReportsForm.valid"
          class="feedback-reports-download">
          <svg class="download-icon" id="download-mono.svg" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.62826 7.81969V2.28369H15.8283V7.81969H20.4953L11.9973 17.6687L3.50626 7.81969H8.62826ZM10.6283 9.82069H7.87126L11.9983 14.6067L16.1273 9.82069H13.8283V4.28369H10.6283V9.82069Z" fill="#0071D0"/>
            <path d="M20.8151 21.7162H3.18506V19.7162H20.8151V21.7162Z" fill="#0071D0"/>
          </svg>
          Download
        </button>
      </div>
    </div>
  </form>
  <div class="landing-feedback-form-preview">
    <div class="preview-important-one">
      <span class="important-text">Important:</span>This is a preview. You
      cannot enter any information.
    </div>
    <div class="preview-feedback-form">
      <app-feedback-form [indexName]="indexName" class="non-clickable" [hideButtons]="true" [showMCQ]="true"></app-feedback-form>
    </div>
  </div>
</div>
